import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { cn } from "@/lib/utils";
import { formatRelative } from "@/lib/format";

const TONE = {
  ok: "border-status-healthy/40 text-status-healthy bg-status-healthy/10",
  syncing: "border-status-in-transit/40 text-status-in-transit bg-status-in-transit/10",
  error: "border-status-critical/40 text-status-critical bg-status-critical/10",
};

const LABEL = { ok: "Webshop live", syncing: "Bijwerken…", error: "Webshop fout" };

export function WebshopPill({ status }) {
  if (!status) return null;
  const tone = TONE[status.state] || "border-status-low/50 text-status-low bg-status-low/10";
  return (
    <Link to="/instellingen" data-testid="webshop-status-pill" title={status.error_message || "Gegevens uit kipkruiden.nl"}
      className={cn("hidden lg:flex items-center gap-2 px-3 h-11 rounded-md border text-xs font-medium uppercase tracking-wider", tone)}>
      <ShoppingBag className="w-4 h-4" />
      <div className="flex flex-col leading-tight">
        <span>{LABEL[status.state] || "Webshop offline"}</span>
        <span className="opacity-70 normal-case tracking-normal font-normal" data-testid="webshop-last-sync">
          Sync: {status.last_success ? formatRelative(status.last_success) : "nog niet"}
        </span>
      </div>
    </Link>
  );
}
